module.exports = __webpack_public_path__ + "img/contacts.60eb27f5.svg";